import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import View from "./view.jsx";
import mqtt_topics from "./../../../mqtt/mqtt_topics";
import ReactDOM from "react-dom/client";
import useCheckMobileScreen from "./useCheckMobileScreen.jsx";
//import "./../css/app.css";

// React 18: ReactDOM.render(element, container) became
// ReactDOM.createRoot(container).render(element). A container may only have one
// root, and this view re-renders into the same container every time a list is
// toggled open, so roots are cached per container element and reused.
const __reactRoots = new WeakMap();
function renderIntoContainer(container, element) {
  let root = __reactRoots.get(container);
  if (!root) {
    root = ReactDOM.createRoot(container);
    __reactRoots.set(container, root);
  }
  root.render(element);
}

const Listview = (props) => {
  let heightandwidth = useCheckMobileScreen() ? "8px" : "12px";
  const mac = mqtt_topics.choosenmac; //"0-5b-96";
  const readingcategorytopic =
    mqtt_topics.fixed_topic_part + mac + "/" + mqtt_topics.readingcategorytopic;
  const [state, setState] = useStateIfMounted({
    readings_categories: [],
  });

  function requestreadingcategorydata() {
    mqtt_topics.busy_Requesting_Data = true;
    props.mqttClient.publish(
      mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
      mqtt_topics.readingcategorytopic
    );
    mqtt_topics.busy_Requesting_Data = false;
    props.mqttClient.subscribe(readingcategorytopic);
    props.mqttClient.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    if (topic == readingcategorytopic) {
      try {
        // message is Buffer
        //console.log(topic, "From Surf Mode: " + message.toString());
        message = JSON.parse(message.toString());
        setState({
          readings_categories: message,
        });
      } catch (error) {
        //console.log(message);
      }
    }
  }

  function requestreading(type) {
    mqtt_topics.busy_Requesting_Data = true;
    props.mqttClient.publish(
      mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
      type
    );
    mqtt_topics.busy_Requesting_Data = false;
  }

  useEffect(() => {
    //ask for how to display
    if (!mqtt_topics.busy_Requesting_Data) {
      requestreadingcategorydata();
    } else {
      setTimeout(function () {
        requestreadingcategorydata();
      }, mqtt_topics.timeouttotrytorequestmqttdata); //wait 1 seconds
    }
  }, []);

  useEffect(
    () => () => {
      props.mqttClient.unsubscribe(readingcategorytopic);
      props.mqttClient.removeListener("message", handleMqttMessage);
    },
    []
  );

  //<hr className="hr" />

  function handleListClick(listid) {
    if (
      document
        .getElementById(listid + "_View")
        .style.display.indexOf("block") === -1
    ) {
      document.getElementById(listid + "_View").style.display = "block";
      document.getElementById(
        listid + "_Icon"
      ).src = require("./../../../images/arrowup.png");
      //console.log("key " + listid);
      let element = (
        <div className="row">
          <View viewId={listid} mqttClient={props.mqttClient} />
        </div>
      );
      mqtt_topics.categories_User_Iswatching.push(
        '"Close ' + listid.replace("_", " ") + '"'
      ); //add
      //console.log(mqtt_topics.categories_User_Iswatching);
      renderIntoContainer(document.getElementById(listid + "_View"), element);
      //ask for readings
      if (!mqtt_topics.busy_Requesting_Data) {
        requestreading(listid.replace("_", " "));
      } else {
        setTimeout(function () {
          requestreading(listid.replace("_", " "));
        }, mqtt_topics.timeouttotrytorequestmqttdata); //wait 1 seconds
      }
    } else {
      document.getElementById(listid + "_View").style.display = "none";
      document.getElementById(
        listid + "_Icon"
      ).src = require("./../../../images/arrowdown.png");
      mqtt_topics.categories_User_Iswatching.splice(
        mqtt_topics.categories_User_Iswatching.indexOf(
          listid.replace("_", " ")
        ),
        1
      ); //remove
      //console.log(mqtt_topics.categories_User_Iswatching);
      //publish close message when tab is closed
      props.mqttClient.publish(
        mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
        "Close " + listid.replace("_", " ")
      );
    }
  }
  if (state.readings_categories.length > 0) {
    return (
      <div>
        {state.readings_categories.map((list) => (
          <div key={list + "_row"}>
            <div className="row">
              <div className="col">
                <div
                  className="card text-center bg-dark headerlist btn-sm loginrow parameters readingtabs"
                  type="button"
                >
                  <div
                    className="card-header"
                    onClick={() => handleListClick(list.replace(" ", "_"))}
                  >
                    <img
                      id={list.replace(" ", "_") + "_Icon"}
                      src={require("./../../../images/arrowdown.png")}
                      style={{
                        height: heightandwidth,
                        width: heightandwidth,
                        position: "absolute",
                        top: 7,
                        left: 20,
                        right: 0,
                        bottom: 7,
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    />
                    {list}
                  </div>
                </div>
              </div>
            </div>
            <div
              id={list.replace(" ", "_") + "_View"}
              style={{ display: "none" }}
            ></div>
          </div>
        ))}
      </div>
    );
  } else {
    return (
      <div className="container">
        <center>
          <img
            src={require("./../../../images/simpleloading.gif")}
            className="simpleloadingview"
          />
          <p>
            <strong>Loading Reading Category ...</strong>
          </p>
        </center>
      </div>
    );
  }
};
export default Listview;
